<script lang="ts">
    import { Link } from '@inertiajs/svelte';
    import type { Snippet } from 'svelte';
    import { Toaster } from '@/components/ui/sonner';

    interface Props {
        title: string;
        description: string;
        children?: Snippet;
    }

    let { title, description, children }: Props = $props();
</script>

<Toaster position="top-right" richColors closeButton />
<div class="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10">
    <div class="w-full max-w-sm">
        <div class="flex flex-col gap-8">
            <div class="flex flex-col items-center gap-4">
                <Link href={route('home')} class="flex flex-col items-center gap-2 font-medium">
                    <img src="/culmex-logo.svg" alt="Culmex" class="h-12 w-auto" />
                    <span class="sr-only">{title}</span>
                </Link>
                <div class="space-y-2 text-center">
                    <h1 class="text-xl font-medium">{title}</h1>
                    <p class="text-center text-sm text-muted-foreground">{description}</p>
                </div>
            </div>
            {@render children?.()}
        </div>
    </div>
</div>
